import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { CustomDivider } from '../../../custom_shared/components';
import { DocumentVisualStore } from '../../../documents/stores';
import { DocumentPreviewStore } from '../../stores';
import { IAppStoreBase, ISessionStoreBase } from '../../types';
import DocumentViewer from './DocumentViewer';
import SideDocumentPreviewHeader from './SideDocumentPreviewHeader';
import './SideDocumentPreview.less';

interface Props {
    appStore: IAppStoreBase;
    sessionStore: ISessionStoreBase;
    documentVisualStore: DocumentVisualStore;
    documentPreviewStore: DocumentPreviewStore;
    lightMode?: boolean;
    showPageNumbers?: boolean;
}

const SideDocumentPreview: React.FC<Props> = ({
    appStore,
    sessionStore,
    documentVisualStore,
    documentPreviewStore,
    lightMode,
    showPageNumbers
}) => {
    return (
        <div className="custom-app-side-document-preview">
            <SideDocumentPreviewHeader
                appStore={appStore}
                sessionStore={sessionStore}
                documentPreviewStore={documentPreviewStore}
                lightMode={lightMode}
            />

            <CustomDivider type="horizontal" />

            <div
                className={`custom-app-document-preview-container ${!documentPreviewStore.showMinimap ? 'minimap-hidden' : ''}`}
            >
                {documentPreviewStore.showNoResultsMessage && (
                    <span className="no-results-found-message">{DocumentPreviewStore.noResultsFoundMessage}</span>
                )}

                <DocumentViewer
                    appStore={appStore}
                    sessionStore={sessionStore}
                    documentPreviewStore={documentPreviewStore}
                    documentVisualStore={documentVisualStore}
                    defaultScale={2}
                    minScale={1.1}
                    minimapWidth={68}
                    minimapTopOffset={20}
                    showMinimap={documentPreviewStore.showMinimap}
                    lightMode={lightMode}
                    showPageNumbers={showPageNumbers}
                />
            </div>
        </div>
    );
};

export default observer(SideDocumentPreview);
